import { InviteCreationStage, UserProfileScreens } from './types'

export const userProfileTitle: Record<string, string> = {
  [UserProfileScreens.Profile]: 'Профиль',
  [UserProfileScreens.Contacts]: 'Доступы',
  [UserProfileScreens.Contact]: 'Контакт',
  [UserProfileScreens.Projects]: 'Проекты',
  [UserProfileScreens.Accesses]: 'Доступы',
  [UserProfileScreens.Autos]: 'Мой транспорт',
  [UserProfileScreens.Auto]: 'Транспортное средство',
  [UserProfileScreens.Invite]: 'Приглашение',
  [UserProfileScreens.InviteCreation]: 'Добавить контакт',
  [UserProfileScreens.Documents]: 'Документы'
}

export const inviteCreationStageTitle: Record<string, string> = {
  [InviteCreationStage.Create]: 'Добавить контакт',
  [InviteCreationStage.Confirmation]: 'Добавить контакт',
  [InviteCreationStage.CreationSucceed]: 'Приглашение отправлено',
  [InviteCreationStage.CreationFailed]: 'Приглашение не отправлено'
}

export const userProfilePathnames: Record<string, string> = {
  [UserProfileScreens.Profile]: '/profile',
  [UserProfileScreens.Contacts]: '/profile/contacts',
  [UserProfileScreens.Contact]: '/profile/contacts',
  [UserProfileScreens.Projects]: '/profile/projects',
  [UserProfileScreens.Autos]: '/profile/autos',
  [UserProfileScreens.Auto]: '/profile/autos',
  [UserProfileScreens.Invite]: '/profile/contacts',
  [UserProfileScreens.InviteCreation]: '/profile/contacts',
  [UserProfileScreens.Documents]: '/profile/documents'
}

export const userProfileBackRoute: Record<string, string> = {
  [UserProfileScreens.Contacts]: UserProfileScreens.Profile,
  [UserProfileScreens.Contact]: UserProfileScreens.Contacts,
  [UserProfileScreens.Projects]: UserProfileScreens.Profile,
  [UserProfileScreens.Accesses]: UserProfileScreens.Profile,
  [UserProfileScreens.Autos]: UserProfileScreens.Profile,
  [UserProfileScreens.Auto]: UserProfileScreens.Autos,
  [UserProfileScreens.Invite]: UserProfileScreens.Contacts,
  [UserProfileScreens.InviteCreation]: UserProfileScreens.Contacts,
  [UserProfileScreens.Documents]: UserProfileScreens.Profile
}

export const userProfileEntities: Record<string, string> = {
  [UserProfileScreens.Autos]: UserProfileScreens.Auto,
  [UserProfileScreens.Contacts]: UserProfileScreens.Contact,
  [UserProfileScreens.Projects]: UserProfileScreens.Project
}
